import { SubscriptionPaymentTerm } from './CompanySubscription';
import { PaymentScheduleType } from './DealInvoice';
import { Product, SubscriptionFrequency } from './Product';

export interface ProductSubscription {
	guid: string;
	product: Product;
	setupFee: number;
	subscriptionFrequency: SubscriptionFrequency;
	successFeeType: SuccessFeeType;
	cancellationFee: number | null;
	isBillingActive: boolean;
	autoRenewal: boolean;
	nextBillingDate: string | null;
	basisPoints: number | null;
	reducedFeeLenderDiscountPercent: number | null;
	minimumSuccessFee: number | null;
	term: number | null;
	agreementSignedBy: string;
	agreementSignedDate: string | null;
	agreementFileName: string;
	canDelete: boolean;
	successFeeTiers: ProductSubscriptionSuccessFeeTier[];
	platformAccessPaymentSchedule: PaymentScheduleType;
	successFeePaymentSchedule: PaymentScheduleType;
	feesCredited: boolean;
	contractFileName: string;
	companyName: string;
	successFeeCap: number;
	includeSbaExclusion: boolean;
	excludedLendersCount: number;
	reducedFeeLendersCount: number;
	paymentTerms: SubscriptionPaymentTerm[];
	paymentTermsComplete: boolean;
	tailPeriodMonths: number | null;
}

export type SuccessFeeType = keyof typeof SuccessFeeTypeMap;
export const SuccessFeeTypeMap = {
	None: 'None',
	Flat: 'Flat',
	Tiered: 'Tiered',
};

export interface ProductSubscriptionSuccessFeeTier {
	guid: string;
	basisPoints: number;
	lowerFundingAmount: number;
	upperFundingAmount: number | null;
}
